import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { writeLog } from '../misc/logs';
import { AppSettings, CampaignReport, QuickSMS, ResponsePayload } from '../model';
import { Sender, SenderRequest } from '../model/sender';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(private http: HttpClient) {}

  quickSend(payload: QuickSMS): Observable<ResponsePayload<string>> {
    return this.http.post<ResponsePayload<string>>(
      `${AppSettings.SERVER}/message/quicksend`,
      payload,
      // this.authService.requestOptions()
    );
  }

  getCampaignStatus(id: string): Observable<ResponsePayload<CampaignReport>> {
    return this.http.get<ResponsePayload<CampaignReport>>(
      `${AppSettings.SERVER}/message/campaign/${id}`
    );
  }

  getSenderNames(): Observable<ResponsePayload<Sender[]>> {
    writeLog('sendername', `${AppSettings.SERVER}/message/sendernames`);
    return this.http.get<ResponsePayload<Sender[]>>(
      `${AppSettings.SERVER}/message/sendernames`
    );
  }

  validateSenderName(senderName: string): Observable<ResponsePayload<any>> {
    return this.http.post<ResponsePayload<any>>(
      `${AppSettings.SERVER}/message/sendernames/validate`,
      {
        sender: senderName
      }
    );
  }
  
  registerSenderName(senderPayload: SenderRequest): Observable<ResponsePayload<any>> {
    return this.http.post<ResponsePayload<any>>(
      `${AppSettings.SERVER}/message/sendernames/register`,
      senderPayload
    );
  }
}
